import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HireTalentLayout from "../../../layouts/HireTalentLayout";
import Loader from "../../../components/loader";
import { fetchHireTalentDashboard } from "../../../redux/features/hire-talent/actions/authAction";
import { useNavigate } from "react-router-dom";
import { hireTalentPaths } from "../../../routes/hire-talent";
import { coachPaths } from "../../../routes/coach";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dashboardData } = useSelector(
    (state) => state.hireTalent.auth
  );
  const [isDashboardLoading, setIsDashboardLoading] = useState(true);

  useEffect(() => {
    setIsDashboardLoading(true);
    dispatch(fetchHireTalentDashboard()).finally(() => {
      setIsDashboardLoading(false);
    });
  }, [dispatch]);

  const pickDashboardValue = (...keys) => {
    for (const key of keys) {
      const value = dashboardData?.[key];
      if (value !== undefined && value !== null && value !== "") {
        return value;
      }
    }
    return "0";
  };

  const totalActiveJobs = pickDashboardValue(
    "total_jobs_posted",
    "total_active_jobs",
    "active_job_posts",
    "total_job_posts",
    "total_jobs_posted"
  );
  const todayActiveJobs = pickDashboardValue(
    "today_jobs_posted",
    "today_active_jobs",
    "today_job_posts",
    "today_jobs_posted"
  );
  const totalHiredThisMonth = pickDashboardValue(
    "total_freelancer_hired",
    "freelancers_hired_this_month",
    "total_freelancers_hired",
    "total_hired"
  );
  const todayHired = pickDashboardValue(
    "today_freelancer_hired",
    "today_freelancers_hired",
    "today_hired"
  );
  const totalNewApplications = pickDashboardValue(
    "total_jobs_application",
    "total_new_applications",
    "new_applications",
    "total_applications"
  );
  const todayNewApplications = pickDashboardValue(
    "today_jobs_application",
    "today_new_applications",
    "today_applications"
  );

  if (isDashboardLoading) {
    return <Loader />;
  }

  return (
    <HireTalentLayout>
      <div className="ct_px_40 ct_mt_36">
        <div className="row">
          <div className="col-xxl-8 col-xl-8  mb-4 mb-xl-0">
            <div className="mb-4">
              <h4 className="mb-0 ct_fs_20  mb-2">Welcome Back, Alex!</h4>
              <p className="ct_grey_text mb-0 ct_fs_14">
                Your Freelance Journey Starts Here, Track and Manage Seamlessly
              </p>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="ct_outline_bg h-100 ct_py_10_px_13">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <p className="ct_fs_14 ct_darkblue_text mb-3">
                        Active Job Posts
                      </p>
                      <h4 className="ct_fs_24_new ct_darkblue_text">
                        {totalActiveJobs}
                      </h4>
                    </div>
                    <img src="../assets/img/dash_icon_1.png" alt="" />
                  </div>
                  <ul className="d-flex align-items-center gap-2">
                    <li className="ct_fs_12 ct_orange_text">
                      <svg
                        width="23"
                        height="24"
                        viewBox="0 0 23 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1696_32114)">
                          <path
                            d="M7.03156 16.2038L15.3574 8.03125"
                            stroke="#FB8500"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                            stroke="#FB8500"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1696_32114">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(11.418 0.6875) rotate(45.5323)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      0%
                    </li>
                    <li className="ct_text_op_2">|</li>
                    <li className="ct_grey_text ct_fs_12">
                      {todayActiveJobs} Job posts created today
                    </li>
                  </ul>
                  <div className="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ct_mt_16">
                    <a onClick={() => navigate(hireTalentPaths.PostJobs)} className="ct_yellow_link ct_fs_14">
                      View Report
                    </a>
                    <a onClick={() => navigate(hireTalentPaths.PostJobs)} >
                      <svg
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.834 6.3125L1.16732 6.3125M12.834 6.3125L7.83398 11.3125M12.834 6.3125L7.83398 1.3125"
                          stroke="#FFB703"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="ct_outline_bg h-100 ct_py_10_px_13">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <p className="ct_fs_14 ct_darkblue_text mb-3">
                        Freelancers Hired This Month
                      </p>
                      <h4 className="ct_fs_24_new ct_darkblue_text ">
                        {totalHiredThisMonth}
                      </h4>
                    </div>
                    <img src="../assets/img/dash_icon_2.png" alt="" />
                  </div>
                  <ul className="d-flex align-items-center gap-2">
                    <li className="ct_fs_12 ct_sky_blue_text">
                      0%
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1696_32145)">
                          <path
                            d="M5.73231 8.00261L15.8359 13.8359"
                            stroke="#8ECAE6"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.74891 15.7105L16.1237 14.0024L14.4156 7.6276"
                            stroke="#8ECAE6"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1696_32145">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(21.8555 8.07031) rotate(120)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </li>
                    <li className="ct_text_op_2">|</li>
                    <li className="ct_grey_text ct_fs_12">
                      {todayHired} Freelancers hired today
                    </li>
                  </ul>
                  <div className="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ct_mt_16">
                    <a className="ct_dark_blue_link ct_fs_14">
                      View Report
                    </a>
                    <a>
                      <svg
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                          stroke="#023047"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="ct_outline_bg h-100 ct_py_10_px_13">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <p className="ct_fs_14 ct_darkblue_text mb-3">
                        New Applications
                      </p>
                      <h4 className="ct_fs_24_new ">{totalNewApplications} </h4>
                    </div>
                    <img src="../assets/img/dash_icon_3.png" alt="" />
                  </div>
                  <ul className="d-flex align-items-center gap-2">
                    <li className="ct_fs_12 ct_orange_text">
                      <svg
                        width="23"
                        height="24"
                        viewBox="0 0 23 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1696_32114)">
                          <path
                            d="M7.03156 16.2038L15.3574 8.03125"
                            stroke="#FB8500"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.5339 14.3985L15.5952 7.79909L8.99583 7.73778"
                            stroke="#FB8500"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1696_32114">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(11.418 0.6875) rotate(45.5323)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      0%
                    </li>
                    <li className="ct_text_op_2">|</li>
                    <li className="ct_grey_text ct_fs_12">
                      {todayNewApplications} new applications today
                    </li>
                  </ul>
                  <div className="d-flex align-items-center justify-content-between gap-2 ct_pt_16 ct_border_top_light ct_mt_16">
                    <a onClick={() => navigate(hireTalentPaths.Applicants)} className="ct_dark_blue_link ct_fs_14">
                      View Report
                    </a>
                    <a onClick={() => navigate(hireTalentPaths.Applicants)}>
                      <svg
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.834 6.92969L1.16732 6.92969M12.834 6.92969L7.83398 11.9297M12.834 6.92969L7.83398 1.92969"
                          stroke="#023047"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 ct_mb_30">
                <div className="ct_outline_bg">
                  <h4 className="ct_fs_20 ct_darkblue_text ct_mb_10">
                    Book Your First Coaching Session
                  </h4>
                  <p className="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll">
                    Stay aligned, stay accountable. Access your coach profile,
                    track your sessions, and get expert feedback when you need
                    it.
                  </p>
                  <div className="ct_mt_20">
                    <button className="ct_yellow_btn ct_darkblue_btn ct_h_50 px-5" onClick={() => navigate(coachPaths?.WebinarLandingPage)}>
                      Explore CoachHub
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 ct_mb_30">
                <div className="ct_outline_bg">
                  <h4 className="ct_fs_20 ct_darkblue_text ct_mb_10">
                    New Job
                  </h4>
                  <p className="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll">
                    Hi there, you have created 0 job posts that has gone live.
                    All the jobs can be accessed here and you can create new job
                    here too
                  </p>~
                  <div className="ct_mt_20">
                    <button className="ct_yellow_btn  ct_h_50 px-5" onClick={() => navigate(hireTalentPaths?.PostJobs)}>
                      + Create a Job
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row">
              <div className="col-md-12">
                <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                  <h4 className="ct_fs_20  ct_darkblue_text">
                    {" "}
                    Recent Job Posts
                  </h4>
                  <a className="ct_dark_blue_link">View All</a>
                </div>
              </div>

              <div className="col-xxl-4 col-xl-4 col-lg-6 ct_mb_30">
                <div className="ct_outline_bg ct_p_10">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <h4 className="ct_fs_16 ct_darkblue_text mb-2">
                        Senior Full Stack{" "}
                      </h4>
                      <p className="mb-0 ct_fs_12 ct_grey_text">
                        London, England
                      </p>
                    </div>
                    <div>
                      <div className="ct_right_dropdown dropdown mb-2">
                        <button
                          className="p-0 ms-auto"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          width="24px"
                          height="24px"
                          style={{ height: "19px" }}
                        >
                          <i className="fa-solid fa-ellipsis"></i>
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <a
                              className="dropdown-item"
                            
                              data-bs-target="#ct_project_detail_modal"
                              data-bs-toggle="modal"
                            >
                              View Project Details
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_darksky_blue_text"
                              data-bs-target="#ct_Upload_Deliverable_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Upload Deliverable
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_yellow_text"
                              href="javascript:void(0)"
                            >
                              Send Message
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_orange_text"
                              data-bs-target="#ct_markas_complete_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Mark as Complete
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p className="ct_fs_12 ct_darksky_blue_text">
                        6 days ago
                      </p>
                    </div>
                  </div>
                  <ul className="ct_grid_2_new ct_border_top_1_op_10 ct_pt_20">
                    <li className="d-flex align-items-center gap-2 ">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          d="M12.6654 4H3.33203C2.8016 4 2.29289 4.21071 1.91782 4.58579C1.54274 4.96086 1.33203 5.46957 1.33203 6V7.81333L5.89003 9.33333H10.1074L14.6654 7.81333V6C14.6654 5.46957 14.4546 4.96086 14.0796 4.58579C13.7045 4.21071 13.1958 4 12.6654 4Z"
                          fill="#219EBC"
                        />
                        <path
                          d="M6.66536 4V3.33333H9.33203V4H10.6654V3.33333C10.6654 2.97971 10.5249 2.64057 10.2748 2.39052C10.0248 2.14048 9.68565 2 9.33203 2H6.66536C6.31174 2 5.9726 2.14048 5.72256 2.39052C5.47251 2.64057 5.33203 2.97971 5.33203 3.33333V4H6.66536ZM5.89003 9.33333L1.33203 7.81333V12C1.33256 12.5303 1.54344 13.0387 1.9184 13.4136C2.29336 13.7886 2.80176 13.9995 3.33203 14H12.6654C13.1956 13.9995 13.704 13.7886 14.079 13.4136C14.454 13.0387 14.6648 12.5303 14.6654 12V7.81333L10.1074 9.33333H5.89003Z"
                          fill="#219EBC"
                        />
                      </svg>
                      <span className="ct_fs_12"> Experienced</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.02344 15L10.0234 16H2V2H6C6 1.72396 6.05208 1.46615 6.15625 1.22656C6.26042 0.986979 6.40365 0.773438 6.58594 0.585938C6.76823 0.398438 6.97917 0.255208 7.21875 0.15625C7.45833 0.0572917 7.71875 0.00520833 8 0C8.27604 0 8.53385 0.0520833 8.77344 0.15625C9.01302 0.260417 9.22656 0.403646 9.41406 0.585938C9.60156 0.768229 9.74479 0.979167 9.84375 1.21875C9.94271 1.45833 9.99479 1.71875 10 2H14V10.0234L13 11.0234V3H12V5H4V3H3V15H9.02344ZM5 3V4H11V3H9V2C9 1.85938 8.97396 1.72917 8.92188 1.60938C8.86979 1.48958 8.79948 1.38542 8.71094 1.29688C8.6224 1.20833 8.51562 1.13542 8.39062 1.07812C8.26562 1.02083 8.13542 0.994792 8 1C7.85938 1 7.72917 1.02604 7.60938 1.07812C7.48958 1.13021 7.38542 1.20052 7.29688 1.28906C7.20833 1.3776 7.13542 1.48438 7.07812 1.60938C7.02083 1.73438 6.99479 1.86458 7 2V3H5ZM15.8516 11.3516L11.5 15.7109L9.39844 13.6016L10.1016 12.8984L11.5 14.2891L15.1484 10.6484L15.8516 11.3516Z"
                          fill="#219EBC"
                        />
                      </svg>

                      <span className="ct_fs_12"> 15 Applications</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12"> Seasonal</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12" style={{ color: "#FF3B30" }}>
                        {" "}
                        Mar 4, 2025
                      </span>
                    </li>
                  </ul>
                  <p className="mb-0 ct_fs_12 ct_grey_text ct_mt_40">
                    We’re looking for a seasoned full stack developer to help
                    build and scale enterprise level web application.
                  </p>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-6 ct_mb_30">
                <div className="ct_outline_bg ct_p_10">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <h4 className="ct_fs_16 ct_darkblue_text mb-2">
                        Senior Full Stack{" "}
                      </h4>
                      <p className="mb-0 ct_fs_12 ct_grey_text">
                        London, England
                      </p>
                    </div>
                    <div>
                      <div className="ct_right_dropdown dropdown mb-2">
                        <button
                          className="p-0 ms-auto"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          width="24px"
                          height="24px"
                          style={{ height: "19px" }}
                        >
                          <i className="fa-solid fa-ellipsis"></i>
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <a
                              className="dropdown-item"
                            
                              data-bs-target="#ct_project_detail_modal"
                              data-bs-toggle="modal"
                            >
                              View Project Details
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_darksky_blue_text"
                              data-bs-target="#ct_Upload_Deliverable_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Upload Deliverable
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_yellow_text"
                              href="javascript:void(0)"
                            >
                              Send Message
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_orange_text"
                              data-bs-target="#ct_markas_complete_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Mark as Complete
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p className="ct_fs_12 ct_darksky_blue_text">
                        6 days ago
                      </p>
                    </div>
                  </div>
                  <ul className="ct_grid_2_new ct_border_top_1_op_10 ct_pt_20">
                    <li className="d-flex align-items-center gap-2 ">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          d="M12.6654 4H3.33203C2.8016 4 2.29289 4.21071 1.91782 4.58579C1.54274 4.96086 1.33203 5.46957 1.33203 6V7.81333L5.89003 9.33333H10.1074L14.6654 7.81333V6C14.6654 5.46957 14.4546 4.96086 14.0796 4.58579C13.7045 4.21071 13.1958 4 12.6654 4Z"
                          fill="#219EBC"
                        />
                        <path
                          d="M6.66536 4V3.33333H9.33203V4H10.6654V3.33333C10.6654 2.97971 10.5249 2.64057 10.2748 2.39052C10.0248 2.14048 9.68565 2 9.33203 2H6.66536C6.31174 2 5.9726 2.14048 5.72256 2.39052C5.47251 2.64057 5.33203 2.97971 5.33203 3.33333V4H6.66536ZM5.89003 9.33333L1.33203 7.81333V12C1.33256 12.5303 1.54344 13.0387 1.9184 13.4136C2.29336 13.7886 2.80176 13.9995 3.33203 14H12.6654C13.1956 13.9995 13.704 13.7886 14.079 13.4136C14.454 13.0387 14.6648 12.5303 14.6654 12V7.81333L10.1074 9.33333H5.89003Z"
                          fill="#219EBC"
                        />
                      </svg>
                      <span className="ct_fs_12"> Experienced</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.02344 15L10.0234 16H2V2H6C6 1.72396 6.05208 1.46615 6.15625 1.22656C6.26042 0.986979 6.40365 0.773438 6.58594 0.585938C6.76823 0.398438 6.97917 0.255208 7.21875 0.15625C7.45833 0.0572917 7.71875 0.00520833 8 0C8.27604 0 8.53385 0.0520833 8.77344 0.15625C9.01302 0.260417 9.22656 0.403646 9.41406 0.585938C9.60156 0.768229 9.74479 0.979167 9.84375 1.21875C9.94271 1.45833 9.99479 1.71875 10 2H14V10.0234L13 11.0234V3H12V5H4V3H3V15H9.02344ZM5 3V4H11V3H9V2C9 1.85938 8.97396 1.72917 8.92188 1.60938C8.86979 1.48958 8.79948 1.38542 8.71094 1.29688C8.6224 1.20833 8.51562 1.13542 8.39062 1.07812C8.26562 1.02083 8.13542 0.994792 8 1C7.85938 1 7.72917 1.02604 7.60938 1.07812C7.48958 1.13021 7.38542 1.20052 7.29688 1.28906C7.20833 1.3776 7.13542 1.48438 7.07812 1.60938C7.02083 1.73438 6.99479 1.86458 7 2V3H5ZM15.8516 11.3516L11.5 15.7109L9.39844 13.6016L10.1016 12.8984L11.5 14.2891L15.1484 10.6484L15.8516 11.3516Z"
                          fill="#219EBC"
                        />
                      </svg>

                      <span className="ct_fs_12"> 15 Applications</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12"> Seasonal</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12" style={{ color: "#FF3B30" }}>
                        {" "}
                        Mar 4, 2025
                      </span>
                    </li>
                  </ul>
                  <p className="mb-0 ct_fs_12 ct_grey_text ct_mt_40">
                    We’re looking for a seasoned full stack developer to help
                    build and scale enterprise level web application.
                  </p>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-6 ct_mb_30">
                <div className="ct_outline_bg ct_p_10">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <h4 className="ct_fs_16 ct_darkblue_text mb-2">
                        Senior Full Stack{" "}
                      </h4>
                      <p className="mb-0 ct_fs_12 ct_grey_text">
                        London, England
                      </p>
                    </div>
                    <div>
                      <div className="ct_right_dropdown dropdown mb-2">
                        <button
                          className="p-0 ms-auto"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          width="24px"
                          height="24px"
                          style={{ height: "19px" }}
                        >
                          <i className="fa-solid fa-ellipsis"></i>
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <a
                              className="dropdown-item"
                            
                              data-bs-target="#ct_project_detail_modal"
                              data-bs-toggle="modal"
                            >
                              View Project Details
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_darksky_blue_text"
                              data-bs-target="#ct_Upload_Deliverable_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Upload Deliverable
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_yellow_text"
                              href="javascript:void(0)"
                            >
                              Send Message
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_orange_text"
                              data-bs-target="#ct_markas_complete_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Mark as Complete
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p className="ct_fs_12 ct_darksky_blue_text">
                        6 days ago
                      </p>
                    </div>
                  </div>
                  <ul className="ct_grid_2_new ct_border_top_1_op_10 ct_pt_20">
                    <li className="d-flex align-items-center gap-2 ">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          d="M12.6654 4H3.33203C2.8016 4 2.29289 4.21071 1.91782 4.58579C1.54274 4.96086 1.33203 5.46957 1.33203 6V7.81333L5.89003 9.33333H10.1074L14.6654 7.81333V6C14.6654 5.46957 14.4546 4.96086 14.0796 4.58579C13.7045 4.21071 13.1958 4 12.6654 4Z"
                          fill="#219EBC"
                        />
                        <path
                          d="M6.66536 4V3.33333H9.33203V4H10.6654V3.33333C10.6654 2.97971 10.5249 2.64057 10.2748 2.39052C10.0248 2.14048 9.68565 2 9.33203 2H6.66536C6.31174 2 5.9726 2.14048 5.72256 2.39052C5.47251 2.64057 5.33203 2.97971 5.33203 3.33333V4H6.66536ZM5.89003 9.33333L1.33203 7.81333V12C1.33256 12.5303 1.54344 13.0387 1.9184 13.4136C2.29336 13.7886 2.80176 13.9995 3.33203 14H12.6654C13.1956 13.9995 13.704 13.7886 14.079 13.4136C14.454 13.0387 14.6648 12.5303 14.6654 12V7.81333L10.1074 9.33333H5.89003Z"
                          fill="#219EBC"
                        />
                      </svg>
                      <span className="ct_fs_12"> Experienced</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.02344 15L10.0234 16H2V2H6C6 1.72396 6.05208 1.46615 6.15625 1.22656C6.26042 0.986979 6.40365 0.773438 6.58594 0.585938C6.76823 0.398438 6.97917 0.255208 7.21875 0.15625C7.45833 0.0572917 7.71875 0.00520833 8 0C8.27604 0 8.53385 0.0520833 8.77344 0.15625C9.01302 0.260417 9.22656 0.403646 9.41406 0.585938C9.60156 0.768229 9.74479 0.979167 9.84375 1.21875C9.94271 1.45833 9.99479 1.71875 10 2H14V10.0234L13 11.0234V3H12V5H4V3H3V15H9.02344ZM5 3V4H11V3H9V2C9 1.85938 8.97396 1.72917 8.92188 1.60938C8.86979 1.48958 8.79948 1.38542 8.71094 1.29688C8.6224 1.20833 8.51562 1.13542 8.39062 1.07812C8.26562 1.02083 8.13542 0.994792 8 1C7.85938 1 7.72917 1.02604 7.60938 1.07812C7.48958 1.13021 7.38542 1.20052 7.29688 1.28906C7.20833 1.3776 7.13542 1.48438 7.07812 1.60938C7.02083 1.73438 6.99479 1.86458 7 2V3H5ZM15.8516 11.3516L11.5 15.7109L9.39844 13.6016L10.1016 12.8984L11.5 14.2891L15.1484 10.6484L15.8516 11.3516Z"
                          fill="#219EBC"
                        />
                      </svg>

                      <span className="ct_fs_12"> 15 Applications</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12"> Seasonal</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12" style={{ color: "#FF3B30" }}>
                        {" "}
                        Mar 4, 2025
                      </span>
                    </li>
                  </ul>
                  <p className="mb-0 ct_fs_12 ct_grey_text ct_mt_40">
                    We’re looking for a seasoned full stack developer to help
                    build and scale enterprise level web application.
                  </p>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-6 ct_mb_30">
                <div className="ct_outline_bg ct_p_10">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <h4 className="ct_fs_16 ct_darkblue_text mb-2">
                        Senior Full Stack{" "}
                      </h4>
                      <p className="mb-0 ct_fs_12 ct_grey_text">
                        London, England
                      </p>
                    </div>
                    <div>
                      <div className="ct_right_dropdown dropdown mb-2">
                        <button
                          className="p-0 ms-auto"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          width="24px"
                          height="24px"
                          style={{ height: "19px" }}
                        >
                          <i className="fa-solid fa-ellipsis"></i>
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <a
                              className="dropdown-item"
                            
                              data-bs-target="#ct_project_detail_modal"
                              data-bs-toggle="modal"
                            >
                              View Project Details
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_darksky_blue_text"
                              data-bs-target="#ct_Upload_Deliverable_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Upload Deliverable
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_yellow_text"
                              href="javascript:void(0)"
                            >
                              Send Message
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_orange_text"
                              data-bs-target="#ct_markas_complete_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Mark as Complete
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p className="ct_fs_12 ct_darksky_blue_text">
                        6 days ago
                      </p>
                    </div>
                  </div>
                  <ul className="ct_grid_2_new ct_border_top_1_op_10 ct_pt_20">
                    <li className="d-flex align-items-center gap-2 ">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          d="M12.6654 4H3.33203C2.8016 4 2.29289 4.21071 1.91782 4.58579C1.54274 4.96086 1.33203 5.46957 1.33203 6V7.81333L5.89003 9.33333H10.1074L14.6654 7.81333V6C14.6654 5.46957 14.4546 4.96086 14.0796 4.58579C13.7045 4.21071 13.1958 4 12.6654 4Z"
                          fill="#219EBC"
                        />
                        <path
                          d="M6.66536 4V3.33333H9.33203V4H10.6654V3.33333C10.6654 2.97971 10.5249 2.64057 10.2748 2.39052C10.0248 2.14048 9.68565 2 9.33203 2H6.66536C6.31174 2 5.9726 2.14048 5.72256 2.39052C5.47251 2.64057 5.33203 2.97971 5.33203 3.33333V4H6.66536ZM5.89003 9.33333L1.33203 7.81333V12C1.33256 12.5303 1.54344 13.0387 1.9184 13.4136C2.29336 13.7886 2.80176 13.9995 3.33203 14H12.6654C13.1956 13.9995 13.704 13.7886 14.079 13.4136C14.454 13.0387 14.6648 12.5303 14.6654 12V7.81333L10.1074 9.33333H5.89003Z"
                          fill="#219EBC"
                        />
                      </svg>
                      <span className="ct_fs_12"> Experienced</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.02344 15L10.0234 16H2V2H6C6 1.72396 6.05208 1.46615 6.15625 1.22656C6.26042 0.986979 6.40365 0.773438 6.58594 0.585938C6.76823 0.398438 6.97917 0.255208 7.21875 0.15625C7.45833 0.0572917 7.71875 0.00520833 8 0C8.27604 0 8.53385 0.0520833 8.77344 0.15625C9.01302 0.260417 9.22656 0.403646 9.41406 0.585938C9.60156 0.768229 9.74479 0.979167 9.84375 1.21875C9.94271 1.45833 9.99479 1.71875 10 2H14V10.0234L13 11.0234V3H12V5H4V3H3V15H9.02344ZM5 3V4H11V3H9V2C9 1.85938 8.97396 1.72917 8.92188 1.60938C8.86979 1.48958 8.79948 1.38542 8.71094 1.29688C8.6224 1.20833 8.51562 1.13542 8.39062 1.07812C8.26562 1.02083 8.13542 0.994792 8 1C7.85938 1 7.72917 1.02604 7.60938 1.07812C7.48958 1.13021 7.38542 1.20052 7.29688 1.28906C7.20833 1.3776 7.13542 1.48438 7.07812 1.60938C7.02083 1.73438 6.99479 1.86458 7 2V3H5ZM15.8516 11.3516L11.5 15.7109L9.39844 13.6016L10.1016 12.8984L11.5 14.2891L15.1484 10.6484L15.8516 11.3516Z"
                          fill="#219EBC"
                        />
                      </svg>

                      <span className="ct_fs_12"> 15 Applications</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12"> Seasonal</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12" style={{ color: "#FF3B30" }}>
                        {" "}
                        Mar 4, 2025
                      </span>
                    </li>
                  </ul>
                  <p className="mb-0 ct_fs_12 ct_grey_text ct_mt_40">
                    We’re looking for a seasoned full stack developer to help
                    build and scale enterprise level web application.
                  </p>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-6 ct_mb_30">
                <div className="ct_outline_bg ct_p_10">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <h4 className="ct_fs_16 ct_darkblue_text mb-2">
                        Senior Full Stack{" "}
                      </h4>
                      <p className="mb-0 ct_fs_12 ct_grey_text">
                        London, England
                      </p>
                    </div>
                    <div>
                      <div className="ct_right_dropdown dropdown mb-2">
                        <button
                          className="p-0 ms-auto"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          width="24px"
                          height="24px"
                          style={{ height: "19px" }}
                        >
                          <i className="fa-solid fa-ellipsis"></i>
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <a
                              className="dropdown-item"
                            
                              data-bs-target="#ct_project_detail_modal"
                              data-bs-toggle="modal"
                            >
                              View Project Details
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_darksky_blue_text"
                              data-bs-target="#ct_Upload_Deliverable_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Upload Deliverable
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_yellow_text"
                              href="javascript:void(0)"
                            >
                              Send Message
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_orange_text"
                              data-bs-target="#ct_markas_complete_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Mark as Complete
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p className="ct_fs_12 ct_darksky_blue_text">
                        6 days ago
                      </p>
                    </div>
                  </div>
                  <ul className="ct_grid_2_new ct_border_top_1_op_10 ct_pt_20">
                    <li className="d-flex align-items-center gap-2 ">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          d="M12.6654 4H3.33203C2.8016 4 2.29289 4.21071 1.91782 4.58579C1.54274 4.96086 1.33203 5.46957 1.33203 6V7.81333L5.89003 9.33333H10.1074L14.6654 7.81333V6C14.6654 5.46957 14.4546 4.96086 14.0796 4.58579C13.7045 4.21071 13.1958 4 12.6654 4Z"
                          fill="#219EBC"
                        />
                        <path
                          d="M6.66536 4V3.33333H9.33203V4H10.6654V3.33333C10.6654 2.97971 10.5249 2.64057 10.2748 2.39052C10.0248 2.14048 9.68565 2 9.33203 2H6.66536C6.31174 2 5.9726 2.14048 5.72256 2.39052C5.47251 2.64057 5.33203 2.97971 5.33203 3.33333V4H6.66536ZM5.89003 9.33333L1.33203 7.81333V12C1.33256 12.5303 1.54344 13.0387 1.9184 13.4136C2.29336 13.7886 2.80176 13.9995 3.33203 14H12.6654C13.1956 13.9995 13.704 13.7886 14.079 13.4136C14.454 13.0387 14.6648 12.5303 14.6654 12V7.81333L10.1074 9.33333H5.89003Z"
                          fill="#219EBC"
                        />
                      </svg>
                      <span className="ct_fs_12"> Experienced</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.02344 15L10.0234 16H2V2H6C6 1.72396 6.05208 1.46615 6.15625 1.22656C6.26042 0.986979 6.40365 0.773438 6.58594 0.585938C6.76823 0.398438 6.97917 0.255208 7.21875 0.15625C7.45833 0.0572917 7.71875 0.00520833 8 0C8.27604 0 8.53385 0.0520833 8.77344 0.15625C9.01302 0.260417 9.22656 0.403646 9.41406 0.585938C9.60156 0.768229 9.74479 0.979167 9.84375 1.21875C9.94271 1.45833 9.99479 1.71875 10 2H14V10.0234L13 11.0234V3H12V5H4V3H3V15H9.02344ZM5 3V4H11V3H9V2C9 1.85938 8.97396 1.72917 8.92188 1.60938C8.86979 1.48958 8.79948 1.38542 8.71094 1.29688C8.6224 1.20833 8.51562 1.13542 8.39062 1.07812C8.26562 1.02083 8.13542 0.994792 8 1C7.85938 1 7.72917 1.02604 7.60938 1.07812C7.48958 1.13021 7.38542 1.20052 7.29688 1.28906C7.20833 1.3776 7.13542 1.48438 7.07812 1.60938C7.02083 1.73438 6.99479 1.86458 7 2V3H5ZM15.8516 11.3516L11.5 15.7109L9.39844 13.6016L10.1016 12.8984L11.5 14.2891L15.1484 10.6484L15.8516 11.3516Z"
                          fill="#219EBC"
                        />
                      </svg>

                      <span className="ct_fs_12"> 15 Applications</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12"> Seasonal</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12" style={{ color: "#FF3B30" }}>
                        {" "}
                        Mar 4, 2025
                      </span>
                    </li>
                  </ul>
                  <p className="mb-0 ct_fs_12 ct_grey_text ct_mt_40">
                    We’re looking for a seasoned full stack developer to help
                    build and scale enterprise level web application.
                  </p>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-6 ct_mb_30">
                <div className="ct_outline_bg ct_p_10">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div>
                      <h4 className="ct_fs_16 ct_darkblue_text mb-2">
                        Senior Full Stack{" "}
                      </h4>
                      <p className="mb-0 ct_fs_12 ct_grey_text">
                        London, England
                      </p>
                    </div>
                    <div>
                      <div className="ct_right_dropdown dropdown mb-2">
                        <button
                          className="p-0 ms-auto"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          width="24px"
                          height="24px"
                          style={{ height: "19px" }}
                        >
                          <i className="fa-solid fa-ellipsis"></i>
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <a
                              className="dropdown-item"
                            
                              data-bs-target="#ct_project_detail_modal"
                              data-bs-toggle="modal"
                            >
                              View Project Details
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_darksky_blue_text"
                              data-bs-target="#ct_Upload_Deliverable_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Upload Deliverable
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_yellow_text"
                              href="javascript:void(0)"
                            >
                              Send Message
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item ct_orange_text"
                              data-bs-target="#ct_markas_complete_modal"
                              data-bs-toggle="modal"
                              href="javascript:void(0)"
                            >
                              Mark as Complete
                            </a>
                          </li>
                        </ul>
                      </div>
                      <p className="ct_fs_12 ct_darksky_blue_text">
                        6 days ago
                      </p>
                    </div>
                  </div>
                  <ul className="ct_grid_2_new ct_border_top_1_op_10 ct_pt_20">
                    <li className="d-flex align-items-center gap-2 ">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          d="M12.6654 4H3.33203C2.8016 4 2.29289 4.21071 1.91782 4.58579C1.54274 4.96086 1.33203 5.46957 1.33203 6V7.81333L5.89003 9.33333H10.1074L14.6654 7.81333V6C14.6654 5.46957 14.4546 4.96086 14.0796 4.58579C13.7045 4.21071 13.1958 4 12.6654 4Z"
                          fill="#219EBC"
                        />
                        <path
                          d="M6.66536 4V3.33333H9.33203V4H10.6654V3.33333C10.6654 2.97971 10.5249 2.64057 10.2748 2.39052C10.0248 2.14048 9.68565 2 9.33203 2H6.66536C6.31174 2 5.9726 2.14048 5.72256 2.39052C5.47251 2.64057 5.33203 2.97971 5.33203 3.33333V4H6.66536ZM5.89003 9.33333L1.33203 7.81333V12C1.33256 12.5303 1.54344 13.0387 1.9184 13.4136C2.29336 13.7886 2.80176 13.9995 3.33203 14H12.6654C13.1956 13.9995 13.704 13.7886 14.079 13.4136C14.454 13.0387 14.6648 12.5303 14.6654 12V7.81333L10.1074 9.33333H5.89003Z"
                          fill="#219EBC"
                        />
                      </svg>
                      <span className="ct_fs_12"> Experienced</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.02344 15L10.0234 16H2V2H6C6 1.72396 6.05208 1.46615 6.15625 1.22656C6.26042 0.986979 6.40365 0.773438 6.58594 0.585938C6.76823 0.398438 6.97917 0.255208 7.21875 0.15625C7.45833 0.0572917 7.71875 0.00520833 8 0C8.27604 0 8.53385 0.0520833 8.77344 0.15625C9.01302 0.260417 9.22656 0.403646 9.41406 0.585938C9.60156 0.768229 9.74479 0.979167 9.84375 1.21875C9.94271 1.45833 9.99479 1.71875 10 2H14V10.0234L13 11.0234V3H12V5H4V3H3V15H9.02344ZM5 3V4H11V3H9V2C9 1.85938 8.97396 1.72917 8.92188 1.60938C8.86979 1.48958 8.79948 1.38542 8.71094 1.29688C8.6224 1.20833 8.51562 1.13542 8.39062 1.07812C8.26562 1.02083 8.13542 0.994792 8 1C7.85938 1 7.72917 1.02604 7.60938 1.07812C7.48958 1.13021 7.38542 1.20052 7.29688 1.28906C7.20833 1.3776 7.13542 1.48438 7.07812 1.60938C7.02083 1.73438 6.99479 1.86458 7 2V3H5ZM15.8516 11.3516L11.5 15.7109L9.39844 13.6016L10.1016 12.8984L11.5 14.2891L15.1484 10.6484L15.8516 11.3516Z"
                          fill="#219EBC"
                        />
                      </svg>

                      <span className="ct_fs_12"> 15 Applications</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#219EBC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12"> Seasonal</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 4.66406V7.9974L10 9.9974"
                          stroke="#FF3B30"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="ct_fs_12" style={{ color: "#FF3B30" }}>
                        {" "}
                        Mar 4, 2025
                      </span>
                    </li>
                  </ul>
                  <p className="mb-0 ct_fs_12 ct_grey_text ct_mt_40">
                    We’re looking for a seasoned full stack developer to help
                    build and scale enterprise level web application.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
          <div className="col-xxl-4 col-xl-4  mb-4 mb-xl-0">
            <div>
              <div className="ct_orange_bg_card ct_pt_38_pb_50_px_28 d-flex align-items-center justify-content-between gap-2">
                <div>
                  <h3 className="ct_fs_40 mb-2 text-white">0 Interviews</h3>
                  <p
                    className="ct_fs_16 mb-0  text-white"
                    style={{ maxWidth: "300px" }}
                  >
                    You have 0 new interviews from applicants for 0 job
                    openings.
                  </p>
                </div>
                <div>
                  <i className="fa-solid fa-chevron-right text-white"></i>
                </div>
              </div>
              <div className="ct_mt_30 ct_outline_bg px-0 py-4 ct_box_shadow_card_1">
                <h4 className="ct_fs_20 ct_darkblue_text ct_mb_20 px-4">
                  Expiring soon
                </h4>
                <ul className="">
                  <li className="px-4">
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="">
                        <h5 className="ct_fs_16 mb-0 ct_text_clr_757886">
                          Senior UX Designer
                        </h5>
                        <div className="d-flex align-items-center gap-1">
                          <p className="ct_text_clr_757886  ct_fs_14 mb-0">
                            0 Candidates{" "}
                          </p>
                          <p className="ct_text_clr_757886 ct_fs_14 mb-0 ct_dot_5"></p>
                          <p className=" ct_fs_14 mb-0">Expires 0/0</p>
                        </div>
                      </div>
                      <div>
                        <i className="fa-solid fa-arrow-right"></i>
                      </div>
                    </div>
                  </li>
                  <li
                    className="ct_mt_22 ct_pt_22 px-4"
                    style={{ borderTop: "1px solid #E5EFFF" }}
                  >
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="">
                        <h5 className="ct_fs_16 mb-0 ct_text_clr_757886">
                          Director of People Happiness
                        </h5>
                        <div className="d-flex align-items-center gap-1">
                          <p className="ct_text_clr_757886  ct_fs_14 mb-0">
                            0 Candidates{" "}
                          </p>
                          <p className="ct_text_clr_757886 ct_fs_14 mb-0 ct_dot_5"></p>
                          <p className=" ct_fs_14 mb-0">Expires 0/0</p>
                        </div>
                      </div>
                      <div>
                        <i className="fa-solid fa-arrow-right"></i>
                      </div>
                    </div>
                  </li>
                  <li
                    className="ct_mt_22 ct_pt_22 px-4"
                    style={{ borderTop: "1px solid #E5EFFF" }}
                  >
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="">
                        <h5 className="ct_fs_16 mb-0 ct_text_clr_757886">
                          Director of People Happiness
                        </h5>
                        <div className="d-flex align-items-center gap-1">
                          <p className="ct_text_clr_757886  ct_fs_14 mb-0">
                            0 Candidates{" "}
                          </p>
                          <p className="ct_text_clr_757886 ct_fs_14 mb-0 ct_dot_5"></p>
                          <p className=" ct_fs_14 mb-0">Expires 0/0</p>
                        </div>
                      </div>
                      <div>
                        <i className="fa-solid fa-arrow-right"></i>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              {/* <div className="ct_mt_30 ct_outline_bg ct_box_shadow_card_1 h-100">
                <h4 className="ct_fs_20 ct_darkblue_text ct_mb_20">
                  Your Applicants
                </h4>
                <ul className="ct_para_scroll" style={{ maxHeight: "400px" }}>
                  <li className="ct_p_10">
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="../assets/img/Avatar_11.png"
                          className="ct_img_40"
                        />
                        <div>
                          <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                            Nuray Aksoy
                          </h5>
                          <p className="mb-0 ct_grey_text ct_fs_12">
                            Product Manager
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span
                          className="ct_badge ct_white_nowrap ct_border_radius_10 ct_fs_14 d-inline-block  ct_darksky_blue_text"
                          style={{
                            backgroundColor:
                              "hsl(199.09deg 63.77% 72.94% / 10%)",
                            borderColor: "#E1E4EA",
                          }}
                        >
                          In Progress
                        </span>
                        <div className="ct_right_dropdown dropdown mb-2">
                          <button
                            className="p-0 ms-auto"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            width="24px"
                            height="24px"
                            style={{ height: "19px" }}
                          >
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a
                                className="dropdown-item"
                              
                                data-bs-target="#ct_project_detail_modal"
                                data-bs-toggle="modal"
                              >
                                View Application
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_darksky_blue_text"
                                data-bs-target="#ct_Upload_Deliverable_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Move to Next Stage
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_yellow_text"
                                href="javascript:void(0)"
                              >
                                Ratings & Comment
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_orange_text"
                                data-bs-target="#ct_markas_complete_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Remove Applicant
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="ct_p_10">
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="../assets/img/Avatar_11.png"
                          className="ct_img_40"
                        />
                        <div>
                          <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                            Nuray Aksoy
                          </h5>
                          <p className="mb-0 ct_grey_text ct_fs_12">
                            Product Manager
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span
                          className="ct_badge ct_white_nowrap ct_border_radius_10 ct_fs_14 d-inline-block  ct_yellow_text"
                          style={{
                            backgroundColor: "hsl(42.86deg 100% 50.59% / 23%)",
                            borderColor: "var(--yellow)",
                          }}
                        >
                          Need Review
                        </span>
                        <div className="ct_right_dropdown dropdown mb-2">
                          <button
                            className="p-0 ms-auto"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            width="24px"
                            height="24px"
                            style={{ height: "19px" }}
                          >
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a
                                className="dropdown-item"
                              
                                data-bs-target="#ct_project_detail_modal"
                                data-bs-toggle="modal"
                              >
                                View Application
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_darksky_blue_text"
                                data-bs-target="#ct_Upload_Deliverable_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Move to Next Stage
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_yellow_text"
                                href="javascript:void(0)"
                              >
                                Ratings & Comment
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_orange_text"
                                data-bs-target="#ct_markas_complete_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Remove Applicant
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="ct_p_10">
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="../assets/img/Avatar_11.png"
                          className="ct_img_40"
                        />
                        <div>
                          <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                            Nuray Aksoy
                          </h5>
                          <p className="mb-0 ct_grey_text ct_fs_12">
                            Product Manager
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span
                          className="ct_badge ct_white_nowrap ct_border_radius_10 ct_fs_14 px-4 d-inline-block  "
                          style={{
                            backgroundColor: "hsl(135deg 59% 49% / 20%)",
                            borderColor: "#34C759",
                            color: "#34C759",
                          }}
                        >
                          Done
                        </span>
                        <div className="ct_right_dropdown dropdown mb-2">
                          <button
                            className="p-0 ms-auto"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            width="24px"
                            height="24px"
                            style={{ height: "19px" }}
                          >
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a
                                className="dropdown-item"
                              
                                data-bs-target="#ct_project_detail_modal"
                                data-bs-toggle="modal"
                              >
                                View Application
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_darksky_blue_text"
                                data-bs-target="#ct_Upload_Deliverable_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Move to Next Stage
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_yellow_text"
                                href="javascript:void(0)"
                              >
                                Ratings & Comment
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_orange_text"
                                data-bs-target="#ct_markas_complete_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Remove Applicant
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="ct_p_10">
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="../assets/img/Avatar_11.png"
                          className="ct_img_40"
                        />
                        <div>
                          <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                            Nuray Aksoy
                          </h5>
                          <p className="mb-0 ct_grey_text ct_fs_12">
                            Product Manager
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span
                          className="ct_badge ct_white_nowrap ct_border_radius_10 ct_fs_14 d-inline-block  ct_orange_text"
                          style={{
                            backgroundColor: "hsl(32deg 100% 49% / 20%))",
                            borderColor: "#FB8500",
                          }}
                        >
                          Shortlisted
                        </span>
                        <div className="ct_right_dropdown dropdown mb-2">
                          <button
                            className="p-0 ms-auto"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            width="24px"
                            height="24px"
                            style={{ height: "19px" }}
                          >
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a
                                className="dropdown-item"
                              
                                data-bs-target="#ct_project_detail_modal"
                                data-bs-toggle="modal"
                              >
                                View Application
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_darksky_blue_text"
                                data-bs-target="#ct_Upload_Deliverable_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Move to Next Stage
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_yellow_text"
                                href="javascript:void(0)"
                              >
                                Ratings & Comment
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_orange_text"
                                data-bs-target="#ct_markas_complete_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Remove Applicant
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="ct_p_10">
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="../assets/img/Avatar_11.png"
                          className="ct_img_40"
                        />
                        <div>
                          <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                            Nuray Aksoy
                          </h5>
                          <p className="mb-0 ct_grey_text ct_fs_12">
                            Product Manager
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span
                          className="ct_badge ct_white_nowrap ct_border_radius_10 ct_fs_14 d-inline-block  ct_orange_text"
                          style={{
                            backgroundColor: "hsl(32deg 100% 49% / 20%))",
                            borderColor: "#FB8500",
                          }}
                        >
                          Shortlisted
                        </span>
                        <div className="ct_right_dropdown dropdown mb-2">
                          <button
                            className="p-0 ms-auto"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            width="24px"
                            height="24px"
                            style={{ height: "19px" }}
                          >
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a
                                className="dropdown-item"
                              
                                data-bs-target="#ct_project_detail_modal"
                                data-bs-toggle="modal"
                              >
                                View Application
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_darksky_blue_text"
                                data-bs-target="#ct_Upload_Deliverable_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Move to Next Stage
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_yellow_text"
                                href="javascript:void(0)"
                              >
                                Ratings & Comment
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_orange_text"
                                data-bs-target="#ct_markas_complete_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Remove Applicant
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="ct_p_10">
                    <div className="d-flex align-items-center gap-2 justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="../assets/img/Avatar_11.png"
                          className="ct_img_40"
                        />
                        <div>
                          <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                            Nuray Aksoy
                          </h5>
                          <p className="mb-0 ct_grey_text ct_fs_12">
                            Product Manager
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span
                          className="ct_badge ct_white_nowrap ct_border_radius_10 ct_fs_14 d-inline-block  ct_orange_text"
                          style={{
                            backgroundColor: "hsl(32deg 100% 49% / 20%))",
                            borderColor: "#FB8500",
                          }}
                        >
                          Shortlisted
                        </span>
                        <div className="ct_right_dropdown dropdown mb-2">
                          <button
                            className="p-0 ms-auto"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            width="24px"
                            height="24px"
                            style={{ height: "19px" }}
                          >
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a
                                className="dropdown-item"
                              
                                data-bs-target="#ct_project_detail_modal"
                                data-bs-toggle="modal"
                              >
                                View Application
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_darksky_blue_text"
                                data-bs-target="#ct_Upload_Deliverable_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Move to Next Stage
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_yellow_text"
                                href="javascript:void(0)"
                              >
                                Ratings & Comment
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item ct_orange_text"
                                data-bs-target="#ct_markas_complete_modal"
                                data-bs-toggle="modal"
                                href="javascript:void(0)"
                              >
                                Remove Applicant
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </HireTalentLayout>
  );
}

export default Dashboard
